export * from "./DeliveryFormShippingOptionMethodLabel";
